export const rp = (n) => {
  if (n === null || n === undefined) return "-";
  return "Rp" + Number(n).toLocaleString("id-ID");
};

export const CONDITIONS = {
  like_new: { id: "Seperti Baru", en: "Like New", cls: "bg-[#EFF5F2] text-[#2E473D] border-[#B8D9C8]" },
  excellent: { id: "Sangat Bagus", en: "Excellent", cls: "bg-[#F0F6FF] text-[#1E40AF] border-[#BFDBFE]" },
  good: { id: "Bagus", en: "Good", cls: "bg-[#FEFCE8] text-[#854D0E] border-[#FEF08A]" },
  fair: { id: "Ada Minus", en: "Fair", cls: "bg-[#FFF2EE] text-[#991B1B] border-[#FECACA]" },
};

export const ORDER_STATUS = {
  created: { id: "Menunggu Bayar", en: "Awaiting Payment", cls: "bg-amber-100 text-amber-800" },
  paid: { id: "Dibayar", en: "Paid", cls: "bg-blue-100 text-blue-800" },
  cod_confirmed: { id: "COD · Siap Kirim", en: "COD · Ready", cls: "bg-teal-100 text-teal-800" },
  shipped: { id: "Dikirim", en: "Shipped", cls: "bg-indigo-100 text-indigo-800" },
  completed: { id: "Selesai", en: "Completed", cls: "bg-emerald-100 text-emerald-800" },
  cancelled: { id: "Dibatalkan", en: "Cancelled", cls: "bg-rose-100 text-rose-800" },
  refunded: { id: "Dikembalikan", en: "Refunded", cls: "bg-rose-100 text-rose-800" },
};

export const DISPUTE_STATUS = {
  open: { id: "Sengketa Dibuka", en: "Dispute Open", cls: "bg-rose-100 text-rose-800" },
  resolved: { id: "Sengketa Selesai", en: "Dispute Resolved", cls: "bg-gray-100 text-gray-700" },
};

export const fmtDate = (s) => {
  if (!s) return "-";
  try { return new Date(s).toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" }); }
  catch { return s; }
};
